export default __webpack_public_path__ + "static/media/madame_detail14.7769407e.jpg";